var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLikeOn = function SvgLikeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.89 10.95-5.185 5.185a1 1 0 0 1-1.414 0L4.105 10.95a4.167 4.167 0 0 1 5.893-5.893 4.167 4.167 0 0 1 5.892 5.893Z"
  })));
};
export default SvgLikeOn;